namespace GeniuzPOS.QRreport {
    export interface QRyreportForm {
        ReportId: Serenity.StringEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        QrViewName: Serenity.StringEditor;
        QRSubViewName: Serenity.StringEditor;
        QRFunctionsGroupby_A: Serenity.StringEditor;
        QRFunctionsLength_B: Serenity.StringEditor;
        RemarkNote: Serenity.StringEditor;
    }

    export class QRyreportForm extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRyreport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRyreportForm.init)  {
                QRyreportForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(QRyreportForm, [
                    'ReportId', w0,
                    'ReportName', w0,
                    'UrlReport', w0,
                    'DataStructureName', w0,
                    'QrViewName', w0,
                    'QRSubViewName', w0,
                    'QRFunctionsGroupby_A', w0,
                    'QRFunctionsLength_B', w0,
                    'RemarkNote', w0
                ]);
            }
        }
    }
}
